<template>
  <v-btn block large class="sber-btn" @click="loginWithSberId">Войти со Сбер ID</v-btn>
</template>
<script>
export default {
  name: 'LoginWithSberId',
  methods: {
    async loginWithSberId() {
      try {
        const { state, nonce, authorizeUrl } = await this.$store.dispatch('sioRequest', {
          topic: 'auth-login-sber-id',
          pl: {}
        })
        sessionStorage.setItem('sberid_state', state)
        sessionStorage.setItem('sberid_nonce', nonce)

        window.location.href = authorizeUrl
      } catch (e) {
        console.error('Init SberID failed', e)
        alert('Ошибка при инициации входа')
      }
    }
  }
}
</script>


<style scoped>
  .sber-btn {
    background: linear-gradient(10deg, rgb(241, 233, 19) 0%, rgb(146, 200, 36) 35%, rgb(50, 166, 53) 100%) !important;
    color: white !important;
    padding: 10px 20px !important;
    border: none !important;
    border-radius: 6px !important;
    cursor: pointer !important;
    margin-right: 10px !important; 
  }
</style>